import { render, staticRenderFns } from "./cellHeight-editor.vue?vue&type=template&id=8b013244&scoped=true&"
import script from "./cellHeight-editor.vue?vue&type=script&lang=js&"
export * from "./cellHeight-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b013244",
  null
  
)

export default component.exports